import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Page from "../../../shared/components/ui/page/Page";
import pathRouts from "../../../shared/enums/pathRoute";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { enrichmentFilters, makpezaFilter, makpezaFilters } from "../../../shared/utils/entitiesFiltersUtils";
import { getKey, hasTabPermission } from "../../../shared/utils/tabsUtils";
import MySelfLearningWidget from "./mySelfLearningWidget/MySelfLearningWidget";
import BannerItem from "../../../shared/components/features/BannerItem/BannerItem";
import TeachingStaffPortalWidgwt from "./teachingStaffPortalWidgwt/TeachingStaffPortalWidgwt";
import MiniWidget from "../../../shared/components/features/widget/miniWidget/MiniWidget";
import CourseGallery from "../../../shared/components/features/courseGallery/CourseGallery";
import classes from "./ProfessionalDevelopmentPage.module.css";

const ProfessionalDevelopmentPage = () => {

    const navigate = useNavigate();
    const { texts, lang } = useSelector(state => state.translate);
    const { general } = useSelector(state => state.uiData);
    const makpezaFilters = useMemo(() => makpezaFilter(lang), [lang]);
    const enrichmentFiltersList = useMemo(() => enrichmentFilters(lang), [lang]);
    const makpezaCourses = useSelector(state => selectEntitiesByFilters(state, makpezaFilters));
    const enrichmentCourses = useSelector(state => selectEntitiesByFilters(state, enrichmentFiltersList));

    return (
        <Page title={texts.ProfessionalDevelopment} icon={iconsList.professionalDevelopment} onBack={() => navigate(`/${pathRouts.HOME}`)} >
            <div className={classes.PlusLearningPage}>
                <p className={classes.PlusLearningTitel}>{texts.ProfessionalDevelopment}</p>
                <div className={classes.PlusLearningPageContent}>
                    <div className={classes.RightSide}>
                        <div className={classes.TopPart}>
                            <MySelfLearningWidget />
                            {hasTabPermission(getKey("google")) &&
                                <MiniWidget className={classes.ClassroomWidget} text={texts.allClassroomTasks} color={"#FDDB71"} classNameText={classes.textMiniWidget} link={general.classroomLink} />
                            }
                            <TeachingStaffPortalWidgwt className={classes.Widget} />
                        </div>
                        <div className={classes.BottomPart}>
                            {/* <div className={classes.Gallery}>
                            <CourseGallery
                                courses={makpezaCourses}
                                title={texts.makpeza}
                                color="#E2EDF5"
                            />
                        </div> */}
                            <div className={classes.Gallery}>
                                <CourseGallery
                                    courses={enrichmentCourses}
                                    title={texts.enrichmentForYou}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={classes.Banners}>
                        {general?.ProfessionalDevelopmentBanners?.map((banner, index) =>
                            <BannerItem banner={banner} className={classes.Banner} key={index} />
                        )}
                    </div>
                </div>
            </div >
        </Page>
    );
};

export default ProfessionalDevelopmentPage;